export const urlQueryStringToObj = (str: string): Record<string, string> => {
  const blocked = new Set(['__proto__', 'constructor', 'prototype']);
  const toReturn: Record<string, string> = {};

  for (const [key, value] of new URLSearchParams(str).entries()) {
    if (!blocked.has(key)) {
      toReturn[key] = value;
    }
  }

  return toReturn;
};
